import { useSelector } from 'react-redux';
import { getIsNext } from '../../authSlice/authSelectors';

function useGetIsNext(): boolean {
  const isNext = useSelector(getIsNext);
  return isNext;
}

export default useGetIsNext;
